module.exports = __webpack_public_path__ + "40d7470805873ab6b5810e6beb4ba36c.svg";